<template>
  <div class="animated fadeIn">
    <!-- Manual Registrar - Module (New Fleet Entry) AND UPDATE-->
    <b-row>
      <b-col sm="12">
        <div>
          <b-button class="btn btn-danger" variant="none" @click="back">
            <i class="fa fa-chevron-left"></i> Back
          </b-button>
        </div>
        <b-card :header="appendtext + ' Registrar Setup'" class="mt-1">
          <b-alert :show="isShowAlert" variant="success" isShowAlert="false">
            <p>
              Successfully {{ appendtext }}
              <b-button
                v-show="buttonishow"
                variant="primary"
                @click="reload"
                size="sm"
              >
                <i class="fa fa-plus-circle"></i>&nbsp;Registrar
              </b-button>
            </p>
          </b-alert>

          <b-form @submit="onSubmit" v-if="!isShowAlert" autocomplete="off">
            <b-alert :show="errors.length > 0" variant="danger">
              <h6 class="alert-heading">Please fill in all required field!</h6>
              <ul>
                <li v-for="(error, i) in errors" :key="`error-${i}`">
                  {{ error }}
                </li>
              </ul>
            </b-alert>
            <b-form-group label="Transtype*">
              <!-- <v-select v-model="stranstype" :options="transTypeList" label="description"></v-select> -->
              <input
                type="Text"
                class="form-control bg-white"
                @click="onGetFleetregisterType"
                v-model="registertype"
                readonly
              />
            </b-form-group>
            <b-form-group label="Parking Lane*">
              <!-- <v-select v-model="sparkinglane" :options="parkinglaneoption" label="laneOccupaid"></v-select> -->
              <input
                type="Text"
                class="form-control bg-white"
                @click="onParkinglane"
                v-model="testarray.Parkinglane"
                readonly
              />
            </b-form-group>
            <b-form-group id="exampleInputGroup1" label="Trucker*">
              <!-- <v-select v-model="selectedtrucker" :options="truckerList" label="ownername"></v-select> -->

              <input
                type="Text"
                class="form-control bg-white"
                @click="onTruckerlist"
                v-model="fleetownername"
                readonly
              />
            </b-form-group>

            <b-form-group label="License no.*">
              
            <input
              type="text"
              class="form-control bg-white"
              @click="getExistingLicense"
              v-model="licensedescription"
              placeholder="Manual encode License here"
              list="LicenseItem"
            />

              <datalist id="LicenseItem">
                <option v-for="(item, index) in LicenseItem"
                :key="index">{{ item }}</option>
              </datalist>

            <!-- without suggestion -->
             <!-- <b-form-input
              v-model="licensedescription"
              placeholder="Manual encode License here"
            ></b-form-input> -->

            </b-form-group>

            <b-form-group label="Plate no*">
              <input
              type="text"
              class="form-control bg-white"
              @click="getExistingPlateNo"
              v-model="PlateDescription"
              placeholder="Manual encode License here"
              list="PlateNoItem"
            />

              <datalist id="PlateNoItem">
                <option v-for="(item, index) in PlateNoItem"
                :key="index">{{ item }}</option>
              </datalist>

            <!-- without suggestion -->
            <!-- <b-form-input
              v-model="PlateDescription"
              placeholder="Manual encode Plate Number here"
            ></b-form-input -->
            </b-form-group> 

            <b-form-group id="exampleInputGroup2" label="Vehicletype*">
              <input
                type="text"
                class="form-control bg-white"
                id="fleetype"
                v-model="vehiclediscription"
                placeholder="Vehicle Type"
                @click="getExistingVehicleType"
                list="VTypeItem"
              />
              <!-- @click="onVehicletype" -->
              <datalist id="VTypeItem">
                <option v-for="(item, index) in VTypeItem"
                :key="index">{{ item }}</option>
              </datalist>

            </b-form-group>

            <b-form-group label="Arrival Date Time*">
              <b-input-group>
                <vue-ctk-date-time-picker
                  no-header
                  v-model="form.arrivaldatetime"
                ></vue-ctk-date-time-picker>
              </b-input-group>
            </b-form-group>

            <!-- <b-form-group label="Scan Code">
              <b-input-group>
                <b-form-input disabled placeholder="Auto generated " v-model.trim="form.scancode"></b-form-input>
                <b-input-group-append></b-input-group-append>
              </b-input-group>
            </b-form-group> -->

            <b-form-group label="Document / Reference No*">
              <b-input-group>
                <b-form-input v-model.trim="form.refdocument"></b-form-input>
                <b-input-group-append></b-input-group-append>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Remarks">
              <b-form-textarea
                id="textarea1"
                placeholder="Enter something"
                :rows="3"
                :max-rows="6"
                v-model.trim="form.remarks"
              ></b-form-textarea>
            </b-form-group>

            <div class="dispatch-table">
              <b-button type="submit" variant="primary">
                <i class="fa fa-save"></i>
                {{ appendtext }}
              </b-button>
            </div>
            <!-- <div class="dispatch-list">
              <b-button type="submit" variant="primary" class="btn btn-primary btn-sm btn-block">
                <i class="fa fa-save"></i>
                {{appendtext}}
              </b-button>
            </div> -->
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <!-- modal for trucker -->
    <b-modal
      v-model="Truckerlistmodal"
      title="Select Trucker"
      @ok="onOkModalTrucker"
    >
      <form class="form">
        <div style="height: 50vh; overflow-x: auto">
          <b-form-group>
            <input
              type="text"
              class="form-control mb-2"
              v-model="SearchTrucking"
              placeholder="Search Trucker"
            />
            <span v-if="filterTrucking.length == 0">No available trucker.</span>
            <b-list-group-item
              v-for="(item, index) in filterTrucking"
              :key="index"
            >
              <b-form-radio
                name="trucker"
                :value="item"
                v-model="selectedTrucker"
                @change="onSelectedTrucker(item.fleetownerId, item.ownername)"
                >{{ item.ownername }}</b-form-radio
              >
            </b-list-group-item>
          </b-form-group>
        </div>
      </form>
    </b-modal>
    <!-- modal for Plate no -->
    <b-modal
      v-model="Platelistmodal"
      title="Select Plate No"
      @ok="onSelecPlateno"
    >
      <form class="form">
        <div style="height: 50vh; overflow-x: auto">
          <b-form-group>
            <input
              type="text"
              class="form-control mb-2"
              v-model="SearchPlateNo"
              placeholder="Search Plate No."
            />
            <span v-if="filterPlateno.length == 0">No available Plate No.</span>
            <b-list-group-item
              v-for="(item, index) in filterPlateno"
              :key="index"
            >
              <b-form-radio
                v-model="platenoselect"
                name="some-radios"
                :value="item"
                @change="onSelectedPlateno"
              >
                {{ item.plateno + " - " + item.description }}</b-form-radio
              >
            </b-list-group-item>
          </b-form-group>
        </div>
      </form>
    </b-modal>
   
    <!-- modal for transtype -->
    <b-modal v-model="Transtypemodal" title="Select Transtype.">
      <form class="form">
        <div style="height: 50vh; overflow-x: auto">
          <input
            type="text"
            class="form-control mb-2"
            v-model="SearchTranstype"
            placeholder="Search Transtype"
          />
          <span v-if="filterTranstype.length == 0"
            >No available Transtype.</span
          >
          <b-list-group-item
            v-for="item in filterTranstype"
            :key="item.licenseno"
          >
            <b-form-radio
              v-model="TranstypeModel"
              name="some-radios"
              :value="item"
              @change="SelectTranstype"
            >
              {{ item.description }}</b-form-radio
            >
          </b-list-group-item>
        </div>
      </form>
    </b-modal>
    <!-- modal for Lane -->
    <b-modal
      v-model="LaneModal"
      title="Select Parking Lane."
      @ok="lanefunction"
    >
      <form class="form">
        <div style="height: 50vh; overflow-x: auto">
          <input
            type="text"
            class="form-control mb-2"
            v-model="SearchLane"
            placeholder="Search Parking Lane"
          />
          <span v-if="resultQuery.length == 0">No available Parking Lane.</span>

          <b-list-group-item
            v-for="(item, index) in resultQuery"
            :key="index"
          >
          <!-- :key="item.licenseno + index" -->
            <input
              v-model="LaneModel"
              type="checkbox"
              :id="item.laneno"
              :value="item"
              @change="SelectLane($event)"
            />
            {{ item.laneno }}
          </b-list-group-item>
        </div>
      </form>
    </b-modal>
    <b-modal v-model="Vehiclelistmodal" title="Select Vehicle Type">
      <form class="form">
        <div style="height: 50vh; overflow-x: auto">
          <input
            type="text"
            class="form-control mb-2"
            v-model="SearchVehicle"
            placeholder="Search Vehicle Type"
          />
          <span v-if="filterVehicle.length == 0">No available Vehicle.</span>
          <b-list-group-item
            v-for="(item, index) in filterVehicle"
            :key="index"
          >
            <b-form-radio
              v-model="vehicleModel"
              name="some-radios"
              :value="item"
              @change="vehiclestype"
              >{{ item.drpdisplay }}</b-form-radio
            >
          </b-list-group-item>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import Vue from "vue";
import api from "../../../services/api";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Multiselect from "vue-multiselect";

import { watch } from "fs";
import miniToastr from "mini-toastr";
import axios from "axios";
Vue.component("multiselect", Multiselect);

export default {
  components: {
    "vue-ctk-date-time-picker": VueCtkDateTimePicker,
  },
  data() {
    return {
      value: "",
      Vehiclelistmodal: false,
      vehiclediscription: "",
      SearchVehicle: "",
      vehicleModel: "",
      options: [
        "Select option",
        "options",
        "selected",
        "mulitple",
        "label",
        "searchable",
        "clearOnSelect",
        "hideSelected",
        "maxHeight",
        "allowEmpty",
        "showLabels",
        "onChange",
        "touched",
      ],
      SearchTrucking: "",
      SearchPlateNo: "",
      SearchLicense: "",
      checkedCategories: [],
      mainCategories: [
        {
          merchantId: "1",
        },
        {
          merchantId: "2",
        },
      ], //testing with data use: [{done:false,content:'testing'}]

      appendtext: this.$route.params.id == undefined ? "Create" : "Update",
      buttonishow: this.$route.params.id == undefined ? true : false,
      errors: [],
      isShowAlert: false,
      SearchTranstype: "",
      fleetownername: "",
      truckerList: [],
      Transtypemodal: false,
      TranstypeModel: "",
      LicenseModel: {},
      licensedescription: "",
      SearchLane: "",
      Truckerlistmodal: false,
      LaneModal: false,
      LaneModel: [],
      registertype: "",
      PlateDescription: "",
      Platelistmodal: false,
      platenoselect: {},
      Licenselistmodal: false,
      radioplateno: "",
      transTypeList: [],
      plateoption: [],
      DriverItem: [],
      parkinglaneoption: [],

      stranstype: {},
      sparkinglane: "",
      selectedTrucker: "",
      selectedPlateno: "",
      selectedLicenseno: "",
      testarray: {
        Parkinglane: [],
      },
      vehicletypelist: [],
      vehicle: {
        fleetownerId: "",
        plateno: "",
        vehicletype: "",
        description: "",
        checklistId: 0,
        status: "",

        created_by:
          this.$store.getters.user.firstname +
          " " +
          this.$store.getters.user.lastname,
        create_date: "2017-05-11T14:35:31",
      },

      form: {
        fleetregistryId:
          this.$route.params.id == undefined ? "" : this.$route.params.id,

        branfleetownerId: "",
        regtype: "",
        plateno: this.PlateDescription,

        licenseno: this.licensedescription,
        parkinglane: "",
        arrivaldatetime: "",
        scancode: "",

        refdocument: "",
        remarks: "",
        ismailed: 0,
        brancode: this.$store.getters.selectedWarehouse,
        created_by:
          this.$store.getters.user.firstname +
          " " +
          this.$store.getters.user.lastname,
        create_date: "",
      },
      //added 10-14
      item: '',
      LicenseItem: [],
      PlateNoItem: [],
      VTypeItem: null
    };
  },
  computed: {
    filterTrucking: function () {
      var self = this;
      return this.truckerList.filter(function (cust) {
        return (
          cust.ownername
            .toLowerCase()
            .indexOf(self.SearchTrucking.toLowerCase()) >= 0
        );
      });
    },
    filterPlateno: function () {
      var self = this;
      return this.plateoption.filter(function (cust) {
        return (
          cust.vehicletype
            .toLowerCase()
            .indexOf(self.SearchPlateNo.toLowerCase()) >= 0
        );
      });
    },
    filterTranstype: function () {
      var self = this;
      return this.transTypeList.filter(function (cust) {
        return (
          cust.description
            .toLowerCase()
            .indexOf(self.SearchTranstype.toLowerCase()) >= 0
        );
      });
    },
    
    filterLicense: function () {
      var self = this;
      return self.DriverItem.filter(function (cust) {
        return (
          cust.firstname
            .toLowerCase()
            .indexOf(self.SearchLicense.toLowerCase()) >= 0 ||
          cust.lastname
            .toLowerCase()
            .indexOf(self.SearchLicense.toLowerCase()) >= 0 ||
          cust.middlename
            .toLowerCase()
            .indexOf(self.SearchLicense.toLowerCase()) >= 0
        );
      });
    },
    filterLane: function () {
      var self = this;
      return this.parkinglaneoption.filter(function (cust) {
        return (
          cust.laneno.toLowerCase().indexOf(self.SearchLane.toLowerCase()) >= 0
        );
      });
    },

    filterVehicle: function () {
      var self = this;
      return this.vehicletypelist.filter(function (cust) {
        return (
          cust.drpdisplay
            .toLowerCase()
            .indexOf(self.SearchVehicle.toLowerCase()) >= 0
        );
      });
    },

    resultQuery: function () {
      if (this.SearchLane) {
        return this.parkinglaneoption.filter((taskList) => {
          return this.SearchLane.toLowerCase()
            .split(" ")
            .every((v) => taskList.laneno.toLowerCase().includes(v));
        });
      } else {
        return this.parkinglaneoption;
        console.log(this.parkinglaneoption[i].laneno);
      }
    },
  },

  methods: {
    check: function (e) {
      if (e.target.checked) {
        console.log(e.target.value);
      }
    },

    onSelectedLicense: function () {},

    onSelectDriver(val) {
      this.licensedescription = val.licenseno;
      this.form.licenseno = val.licenseno;
    },
    onOkModalTrucker: function () {
     
      if (this.licensedescription.length > 1) {
        this.getExistingLicense();}

    },

    onSelectedTrucker(id, owner) {
      this.form.branfleetownerId = id;
      this.fleetownername = owner;
      this.PlateDescription = "";
      // this.form.plateno = "";
      // this.form.licenseno = "";
      this.licensedescription = "";
      // this.onPlatelist();
      // this.onLicenseNo();
    },

    // checkForm: function (e) {
    //   if (
    //     this.form.regtype &&
    //     this.form.plateno &&
    //     this.form.licenseno &&
    //     this.form.parkinglane &&
    //     this.form.arrivaldatetime &&
    //     this.form.refdocument
    //   ) {
    //     return true;
    //   }

    //   this.errors = [];

    //   if (!this.form.regtype) {
    //     this.errors.push("Trans type required");
    //   }
    //   if (!this.form.plateno) {
    //     this.errors.push("Plate no required.");
    //   }

    //   if (!this.form.licenseno) {
    //     this.errors.push("License no required.");
    //   }
    //   if (!this.form.parkinglane) {
    //     this.errors.push("Parking lane required.");
    //   }
    //   if (!this.form.arrivalDateTime) {
    //     this.errors.push("Arrival Date Time required.");
    //   }
    //   if (!this.form.refdocument) {
    //     this.errors.push("Document / Reference no required.");
    //   }

    //   //e.preventDefault();
    // },

    onSubmit: function (evt, action) {
      // if (!this.checkForm()) {
      //   return;
      // }
     this.$store.commit("setLoading", true);

      if (this.appendtext == "Create") {
        evt.preventDefault();
        this.form.licenseno = this.licensedescription;
        this.form.plateno = this.PlateDescription;
        this.vehicle.fleetownerId = this.form.branfleetownerId;
        this.vehicle.plateno = this.PlateDescription;

        axios
          .post(
            this.$store.state.IFMSURLlocal + "IFMS_FleetRegistry?action=1",
            this.form
          )
          .then(() => {
            this.isShowAlert = true;
           this.$store.commit("setLoading", false);
          })
          .catch(function (err) {
            this.$store.commit("setLoading", false);
            api.httpMsg(this, err.status, err.data);
          });

        api.instance
          .post("add-fleet", this.vehicle)
          .then(() => {
            this.isShowAlert = true;
            this.$store.commit("setLoading", false);
          })
          .catch(function (err) {
            api.httpMsg(this, err.status, err.data);
            this.$store.commit("setLoading", false);
          });
      } else if (this.appendtext == "Update") {
        evt.preventDefault();
        this.form.licenseno = this.licensedescription;
        this.form.plateno = this.PlateDescription;
        this.vehicle.fleetownerId = this.form.branfleetownerId;
        this.vehicle.plateno = this.PlateDescription;
        axios
          .post(
            this.$store.state.IFMSURLlocal + "IFMS_FleetRegistry?action=3",
            this.form
          )
          .then(() => {
            this.isShowAlert = true;
            this.$store.commit("setLoading", false);
          })
          .catch(function (err) {
            this.$store.commit("setLoading", false);
            api.httpMsg(this, err.status, err.data);
          });

        api.instance
          .put("edit-fleet", this.form)
          .then(() => {
            this.$store.commit("setLoading", false);
            this.isShowAlert = true;
          })
          .catch(function (err) {
            api.httpMsg(this, err.status, err.data);
            this.$store.commit("setLoading", false);
          });
      }
    },

    onTruckerlist: function () {
      this.$store.commit("setLoading", true);
      this.truckerList = [];
      let self = this;
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-active-trucker?brancode=" +
            self.$store.getters.selectedWarehouse +
            "&appname=WFMS"
        )
        .then((resp) => {
          resp.data.forEach((element) => {
            self.truckerList.push({
              fleetownerId: element.fleetownerId,
              id: element.id,
              ownername: element.ownername,
            });
          });

          self.$store.commit("setLoading", false);
          self.Truckerlistmodal = true;
          this.getExistingLicense();
          //this.onPlatelist();
        })
        .catch(function (err) {
          self.$store.commit("setLoading", false);
          api.httpMsg(self, err.status, err.data);
        });
    },

    onPlatelist: function () {
      this.$store.commit("setLoading", true);
      this.plateoption = [];
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-plate-no?param=" +
            this.form.branfleetownerId
        )
        .then((resp) => {
          resp.data.forEach((element) => {
            this.plateoption.push({
              branfleetownerId: element.fleetownerId,
              checklistId: element.checklistId,
              create_date: element.create_date,
              created_by: element.created_by,
              description: element.description,
              plateno: element.plateno,
              status: element.status,
              vehicletype: element.vehicletype,
            });
          });
          // console.log(this.plateoption[0].plateno);
          this.$store.commit("setLoading", false);
          // if(resp.data.length == 1) {
          //   this.PlateDescription = resp.data[0].plateno
          // }
          // else if(resp.data.length >= 2) {
          //   this.Platelistmodal = true;
          // }

          // this.Platelistmodal = true;
        })
        .catch(function (err) {
          this.$store.commit("setLoading", false);
          api.httpMsg(this, err.status, err.data);
          miniToastr.error(err.data);
        });
    },

    onSelectedPlateno(val) {
      this.form.plateno = val.plateno;
      this.PlateDescription = val.plateno;
      // + " - (" + val.vehicletype + ")"
    },

    onSelecPlateno: function () {},

    reload: function () {
      this.$router.go(this.$router.currentRoute);
    },

    back: function () {
      this.$router.push("/Activity/637471940881413464");
    },

    onGetActiveFleetOwner: function () {
      let self = this;
      self.$store.commit("setLoading", true);
      api.instance
        .get(
          this.$store.state.IFMSURLlocal +
            "get-active-trucker?brancode=" +
            self.$store.getters.selectedWarehouse +
            "&appname=WFMS"
        )
        .then(function (resp) {
          self.truckerList = resp.data;
          self.$store.commit("setLoading", false);
        })
        .catch(function (err) {
          self.$store.commit("setLoading", false);
          api.httpMsg(self, err.status, err.data);
        });
    },

    SelectTranstype(val) {
      this.registertype = val.description;
      this.form.regtype = val.regtype;
      this.Parkinglane = "";
      this.LaneModel = [];
    },

    onGetFleetregisterType() {
      //get type reigster inbound or outbound
      let self = this;
      self.transTypeList = [];
      self.$store.commit("setLoading", true);
      axios
        .get(this.$store.state.IFMSURLlocal + "get-registry-type")
        .then(function (resp) {
          resp.data.forEach((element) => {
            self.transTypeList.push({
              description: element.description,
              regtype: element.regtype,
            });
          });
          self.$store.commit("setLoading", false);
          self.Transtypemodal = true;
        })
        .catch(function (err) {
          api.httpMsg(self, err.status, err.data);
          self.$store.commit("setLoading", false);
        });
    },

    onParkinglane: function () {
      let self = this;
      self.parkinglaneoption = [];
      self.$store.commit("setLoading", true);
      api.instance
        .get(
          this.$store.state.IFMSURLlocal +
            "get-select-fleetparkinglane?brancode=" +
            self.$store.getters.selectedWarehouse +
            "&trantype=" +
            self.form.regtype
        )
        .then(function (resp) {
          resp.data.forEach((element) => {
            self.parkinglaneoption.push({
              id: element.id,
              laneno: element.laneno,
              laneOccupaid: element.laneOccupaid,
            });
          });
          self.$store.commit("setLoading", false);
          self.LaneModal = true;
        })
        .catch(function (err) {
          self.$store.commit("setLoading", false);
          api.httpMsg(self, err.status, err.data);
        });
    },

    SelectLane: function (e) {
      //  var index = this.LaneModel.indexOf(laneno);
      //  console.log(this.LaneModel);
      this.form.parkinglane = "";
      this.testarray.Parkinglane = [];
    },

    lanefunction() {
      if (this.LaneModel == null) {
        this.form.parkinglane = "";
        this.testarray.Parkinglane = [];
      } else if (this.LaneModel.length == 1) {
        this.form.parkinglane = this.LaneModel[0].id;
        this.testarray.Parkinglane = this.LaneModel[0].laneno;
      } else {
        for (var i = 0; i < this.LaneModel.length; i++) {
          this.testarray.Parkinglane.push(this.LaneModel[i].laneno);
        }
      }

      this.form.parkinglane = this.LaneModel.map(
        (lane) => lane.laneno
      ).toString();

      // console.log(this.form.parkinglane)
    },

    onLicenseNo: function () {
      let self = this;
      self.DriverItem = [];
      self.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-driver-by-truckercode?val=" +
            this.form.branfleetownerId
        )
        .then(function (resp) {
          resp.data.forEach((element) => {
            self.DriverItem.push({
              licenseno: element.licenseno,
              truckercode: element.truckercode,
              lastname: element.lastname,
              firstname: element.firstname,
              middlename: element.middlename,
              nickname: element.nickname,
              emailadd: element.emailadd,
              contactno: element.contactno,
              status: element.status,
            });
          });

          self.$store.commit("setLoading", false);
          //self.Licenselistmodal = true;
        })
        .catch(function (err) {
          api.httpMsg(self, err.status, err.data);
          self.$store.commit("setLoading", false);
        });
    },

    getData: function () {
      this.onGetActiveFleetOwner();
      let self = this;
      self.$store.commit("setLoading", true);
      if (this.$route.params.id !== undefined) {
        axios
          .get(
            this.$store.state.IFMSURLlocal +
              "get-fleet-registry-By-id?fleetregistryId=" +
              this.$route.params.id
          )
          .then((resp) => {
            self.form = resp.data;
            self.registertype = resp.data.Transtype;
            self.testarray.Parkinglane = resp.data.parkinglane;
            self.licensedescription = resp.data.licenseno;
            self.PlateDescription = resp.data.plateno;
            self.fleetownername = resp.data.branfleetownerId;
          })
          .catch((err) => {
            api.httpMsg(self, err.status, err.data);
            self.$store.commit("setLoading", false);
          });
      }
    },

    vehiclestype: function (val) {
      this.vehicle.vehicletype = val.drpdata;
      this.vehiclediscription = val.drpdisplay;
    },

    onVehicletype: function () {
      this.$store.commit("setLoading", true);
      this.vehicletypelist = [];
      api.instance
        .get("get-select-vehicletype?drpids=VEHICLE")
        .then((resp) => {
          resp.data.forEach((element) => {
            this.vehicletypelist.push({
              id: element.id,
              dropid: element.dropid,
              drpdata: element.drpdata,
              drpdisplay: element.drpdisplay,
            });
          });
          this.Vehiclelistmodal = true;
          this.$store.commit("setLoading", false);
        })
        .catch(function (err) {
          api.httpMsg(this, err.status, err.data);
          this.$store.commit("setLoading", false);
        });
    },
    // added 10-14
    getExistingLicense: function () {
      let self = this;
      self.LicenseItem = [];
      self.$store.commit("setLoading", true);
        axios
          .get(
            this.$store.state.IFMSURLlocal +
              "get-fleet-trucker-license?truckercode=" +
              this.form.branfleetownerId
        )
        .then(function (resp) {
              self.LicenseItem = resp.data.map(f => {
                return f.licenseno
              })
              self.$store.commit("setLoading", false);
          })
        .catch(function (err) {
          api.httpMsg(self, err.status, err.data);
          self.$store.commit("setLoading", false);
        });
    },

    getExistingPlateNo: function () {
      let self = this;
      self.PlateNoItem = [];
      self.$store.commit("setLoading", true);
        axios
          .get(
            this.$store.state.IFMSURLlocal +
              "get-fleet-trucker-plateno?fleetownerId=" +
              this.form.branfleetownerId
        )
        .then(function (resp) {
              self.PlateNoItem = resp.data.map(f => {
                return f.plateno
              })
              self.$store.commit("setLoading", false)
          })
        .catch(function (err) {
          api.httpMsg(self, err.status, err.data);
        });
    },
    getExistingVehicleType: function (){
        let self = this;
      self.VTypeItem = null;
      self.$store.commit("setLoading", true);
      if(this.PlateDescription > 1){
        axios
          .get(
            this.$store.state.IFMSURLlocal +
              "get-fleet-trucker-Vtype?plateno=" +
              this.PlateDescription
        )
        .then(function (resp) {
              self.VTypeItem = resp.data.map(f => {
                return f.vehicletype
              })
              self.$store.commit("setLoading", false)
              })
        .catch(function (err) {
          api.httpMsg(self, err.status, err.data);
        });
      }
      else if (this.PlateDescription == 0){
        this.onVehicletype();
      }
    }
    // if(resp.data.length == 0) {
    //               
    //             }

  },

  watch: {},

  created: function () {
    this.getData();
    this.getExistingLicense();
  },
};
</script>